<template>
	<div class="class" v-katex:auto>
		<teacherHeader :logo_name="logo_name" @info-event="myInfoEvent" @public-event="publicEvent"></teacherHeader>
		<div class="task_cont bg_blue">
			<div class="topic_basket_cont"  v-if="JSON.stringify(data) != '{}'">
				<div class="topic_basket_l bg_white radius8 bs">
					<div class="topic_basket_l_title flex">
						<p class="f26px cl_dark topic_basket_l_title_l">{{data.name}}
						<span class="topic_basket_l_title_btn cl_violet mal15 f14px inline cur tc" @click="editShow">修改名称</span></p>
						<div class="topic_basket_l_title_r flex">
							<button class="topic_basket_l_return cl_violet" @click="$router.go(-1)">返回挑题</button>
							<button class="cl_white topic_basket_l_save" @click="knowledgeShow">
								<img src="../../../static/icon_save.png" class="mar5" />
								<span>保存</span>
							</button>
							<button class="cl_white topic_basket_l_set" @click="outerVisible=true">立即布置</button>
						</div>
					</div>
					<div class="topic_basket_list_cont mat20">
						<div class="topic_basket_list" v-for="(item,index) in data.groupList" :key="index">
							<div class="topic_basket_list_title f20px mab10 flex">
								<p>{{item.number}}、{{item.group_name}}(共{{item.question_list.length}}小题)</p>
								<div class="flex">
									<span class="topic_basket_l_title_btn cl_violet f14px inline cur tc" @click="editTitle(index)">修改名称</span>
									<div class="topic_basket_list_delete cur tc cl_red f14px" @click="removeAll(index)">
										<img src="../../../static/delete_red.png" class="mar5" />
										<span>删除</span>
									</div>
								</div>
							</div>
							<div class="topic_basket_list_question">
								<div class="paper_list mab20" v-for="(second,secondIndex) in item.question_list" :key="secondIndex">
									<div class="paper_list_title f18px cl_dark">
										<div class="paper_list_title_l">{{index + 1}}、</div>
										<div class="paper_list_title_r" v-html="second.title"></div>
									</div>
									<div class="paper_list_check f16px cl_gray mat20" v-if="second.qtpye == '单选题' || second.qtpye == '多选题' || second.qtpye == '双选题' || second.qtpye == '选择题'">
										<div class="paper_list_check_list mat10" v-if="second.option_a != ''">
											<div class="paper_list_check_list_l">A、</div>
											<div class="paper_list_check_list_r" v-html="second.option_a"></div>
										</div>
										<div class="paper_list_check_list mat10" v-if="second.option_b != ''">
											<div class="paper_list_check_list_l">B、</div>
											<div class="paper_list_check_list_r" v-html="second.option_b"></div>
										</div>
										<div class="paper_list_check_list mat10" v-if="second.option_c != ''">
											<div class="paper_list_check_list_l">C、</div>
											<div class="paper_list_check_list_r" v-html="second.option_c"></div>
										</div>
										<div class="paper_list_check_list mat10" v-if="second.option_d != ''">
											<div class="paper_list_check_list_l">D、</div>
											<div class="paper_list_check_list_r" v-html="second.option_d"></div>
										</div>
										<div class="paper_list_check_list mat10" v-if="second.option_e != ''">
											<div class="paper_list_check_list_l">E、</div>
											<div class="paper_list_check_list_r" v-html="second.option_e"></div>
										</div>
									</div>
									<div class="" v-else>
										<div class="paper_list_check f16px cl_gray mat20" v-if="second.isSub == 1">
											<div class="paper_list_check_list mat10" v-for="(third,thirdIndex) in second.subquestions" :key="thirdIndex" :id="third.id">
												<div class="paper_list_check_list_l">{{thirdIndex + 1}}、</div>
												<div class="paper_list_check_list_r" v-html="third.title"></div>
											</div>
										</div>
									</div>
									<div class="paper_list_btm flex">
										<div class="flex f16px cl_dark">
											<p class="mar15">难度：
												<span class="cl_red" v-if="second.diff == 1">非常简单</span>
												<span class="cl_red" v-if="second.diff == 2">简单</span>
												<span class="cl_red" v-if="second.diff == 3">一般</span>
												<span class="cl_red" v-if="second.diff == 4">难</span>
												<span class="cl_red" v-if="second.diff == 5">非常难</span>
											</p>
											<p class="mal15">知识点：<span class="cl_red">{{second.knowledges}}</span></p>
										</div>
										<div class="flex">
											<div class="topic_basket_l_title_btn cl_violet f14px cur tc" @click="proofShow(index,secondIndex)">解析</div>
											<div class="topic_basket_list_delete cur tc cl_red" @click="remove(index,secondIndex)">
												<img src="../../../static/delete_red.png" class="mar5" />
												<span>删除</span>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="topic_basket_r bg_white radius8 bs">
					<div class="topic_basket_r_title f20px cl_dark">调整排序</div>
					<draggable :forceFallback="true" @end="end" :list="data.groupList" class="topic_basket_nav_cont">
						<div v-for="(item, index) in data.groupList" :key="index" class="topic_basket_nav">
							<p class="topic_basket_nav_title flex">
								<span class="cl_gray">{{item.number}}、{{item.group_name}}</span>
								<span class="cl_yel f12px">*按住数字拖动</span>
							</p>
							<draggable class="" :forceFallback="true" @end="end2" :list="item.question_list"  group="site" class="topic_basket_nav_item_cont mat10">
								<p v-for="(secondItem,secondIndex) in item.question_list" :key="secondIndex" class="topic_basket_nav_item cl_violet">{{secondIndex + 1}}</p>
							</draggable>
						</div>
					</draggable>
				</div>
			</div>
			<div class="tc cl_gray mat30 f18px" v-else>
				<p>题目列表为空</p>
			</div>
		</div>
		<!-- 修改试卷名称 -->
		<el-dialog title="修改名称" :visible.sync="edit_show" width="30%" center>
		  <div class="f16px paper_dialog_cont">
				<div class="test_screen cl_gray">
					<div class="test_screen_l f16px"><span class="inline">修改名称</span><i class="inline">：</i></div>
					<div class="test_screen_r tc">
						<input type="text" v-model="edit_name" class="found_dialog_item_input f16px" style="width: 100%;" />
					</div>
				</div>
			</div>
		  <div slot="footer" class="f18px mab20">
		    <span @click="edit_show = false" class="cl_violet cur inline paper_dialog_cancel">取消</span>
				<span @click="editConfirm" class="cl_white cur inline paper_dialog_confirm">确定</span>
		  </div>
		</el-dialog>
		<!-- 修改题型名称 -->
		<el-dialog title="修改名称" :visible.sync="edit_title_show" width="30%" center>
		  <div class="f16px paper_dialog_cont">
				<div class="test_screen cl_gray">
					<div class="test_screen_l f16px"><span class="inline">修改名称</span><i class="inline">：</i></div>
					<div class="test_screen_r tc">
						<input type="text" v-model="edit_title_name" class="found_dialog_item_input f16px" style="width: 100%;" />
					</div>
				</div>
			</div>
		  <div slot="footer" class="f18px mab20">
		    <span @click="edit_title_show = false" class="cl_violet cur inline paper_dialog_cancel">取消</span>
				<span @click="editTitleConfirm(edit_title_index)" class="cl_white cur inline paper_dialog_confirm">确定</span>
		  </div>
		</el-dialog>
		<!-- 解析 -->
		<el-dialog title="解析" :visible.sync="proof_show" width="40%" center>
		  <div class="f16px paper_dialog_cont">
				<div class="proof_subject">
					<div class="proof_subject_title f16px" v-html="paper_cur.title"></div>
					<div class="proof_subject_cont cl_gray mat20" v-if="paper_cur.subquestions">
						<div class="proof_subject_list" v-for="(item,index) in paper_cur.subquestions" :key="index" v-html="item.title"></div>
					</div>
					<div class="proof_subject_check mat20" v-if="paper_cur.option_a != ''">
						<div class="proof_subject_check_list" v-if="paper_cur.option_a != ''">
							<div class="proof_subject_check_list_l">A.</div>
							<div class="proof_subject_check_list_r" v-html="paper_cur.option_a"></div>
						</div>
						<div class="proof_subject_check_list" v-if="paper_cur.option_b != ''">
							<div class="proof_subject_check_list_l">B.</div>
							<div class="proof_subject_check_list_r" v-html="paper_cur.option_b"></div>
						</div>
						<div class="proof_subject_check_list" v-if="paper_cur.option_c != ''">
							<div class="proof_subject_check_list_l">C.</div>
							<div class="proof_subject_check_list_r" v-html="paper_cur.option_c"></div>
						</div>
						<div class="proof_subject_check_list" v-if="paper_cur.option_d != ''">
							<div class="proof_subject_check_list_l">D.</div>
							<div class="proof_subject_check_list_r" v-html="paper_cur.option_d"></div>
						</div>
						<div class="proof_subject_check_list" v-if="paper_cur.option_e != ''">
							<div class="proof_subject_check_list_l">E.</div>
							<div class="proof_subject_check_list_r" v-html="paper_cur.option_e"></div>
						</div>
					</div>
				</div>
				<div class="proof_analysis mat20">
					<div class="proof_analysis_l f18px">答案：</div>
					<div class="proof_analysis_r" v-html="paper_cur.answer2"></div>
				</div>
				<div class="proof_analysis mat20">
					<div class="proof_analysis_l f18px">解析：</div>
					<div class="proof_analysis_r" v-html="paper_cur.parse"></div>
				</div>
			</div>
		  <div slot="footer" class="f18px mab20">
		    <span @click="proof_show = false" class="cl_violet cur inline paper_dialog_cancel">关闭</span>
		  </div>
		</el-dialog>
		<!-- 保存试卷 -->
		<el-dialog title="保存试卷" :visible.sync="knowledge_show" width="40%" center>
		  <div class="f16px video_dialog">
				<div class="famous_screen_list">
					<el-select v-model="grade_cur" placeholder="全部">
						<el-option v-for="item in grade":key="item.Id" :label="item.gradeName":value="item.gradeId"></el-option>
					</el-select>
				</div>
				<div class="famous_screen_list mat20">
					<el-select v-model="material_cur" placeholder="全部" @change="materialSelect">
						<el-option v-for="item in material":key="item.Id" :label="item.Name":value="item.Id"></el-option>
					</el-select>
				</div>
				<div class="task_video_nav radius8 mat20 cl_dark" v-if="chapter.length > 0">
					<div class="task_nav_first mab20" v-for="(item,index) in chapter" :key="index">
						<div class="task_nav_first_title f16px cur" @click="firstOpen(index)" :class="{'on':item.open}">
							<img src="../../../static/select_right.png" class="mar5" />
							<span>{{item.gradeName}}</span>
						</div>
						<div class="task_nav_second mat10" v-for="(second,secondIndex) in item.chapter_data" :key="secondIndex" v-if="item.open">
							<div class="task_nav_second_title cur" @click="secondOpen(index,secondIndex)" :class="{'on':second.open}">
								<img src="../../../static/select_right.png" class="mar5" />
								<span class="clip">{{second.chapter}}</span>
							</div>
							<div class="task_nav_three" v-if="second.open">
								<div class="task_nav_three_title clip mat10 cur" v-for="(three,index) in second.section_knowledge_data" :key="index"
								 :class="{'on':three.knowledgeId == chapter_cur}" @click="knowledgeCheck(three.knowledgeId, three.knowledgeName)">{{three.knowledgeName}}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div slot="footer" class="f18px mab20">
			  <span @click="knowledge_show = false" class="cl_violet cur inline paper_dialog_cancel">取消</span>
				<span @click="save" class="cl_white cur inline paper_dialog_confirm">确定</span>
			</div>
		</el-dialog>
		<!-- 布置作业 -->
		<el-dialog title="布置作业" center :visible.sync="outerVisible" width="40%">
			<el-dialog width="35%" title="添加布置对象" center :visible.sync="innerVisible" append-to-body>
				<div class="class_dialog_nav flex">
					<div class="class_dialog_nav_l flex f18px cl_dark">
						<span class="class_dialog_nav_list cur" :class="{'on': class_cur == 'normal_grade_data'}"
						@click="class_cur = 'normal_grade_data'">行政班</span>
						<span class="class_dialog_nav_list cur" :class="{'on': class_cur == 'tutor_grade_data'}"
						@click="class_cur = 'tutor_grade_data'">教学班</span>
					</div>
					<div class="cl_red">*行政班与教学班不可同时布置</div>
				</div>
				<div class="class_dialog_cont cl_dark f16px">
					<div class="class_dialog_list" v-show="class_cur == 'normal_grade_data'">
						<div v-for="(item,index) in class_data.normal_grade_data" :class="index">
							<div class="mat20 mab20">{{item.gradeName}}</div>
							<div class="class_dialog_list_cont tc">
								<div class="cur radius8 class_dialog_list_item" v-for="(item,secondIndex) in item.class_data" :key="secondIndex"
								:class="{'on':item.check}" @click="normalCheck(index,secondIndex)">{{item.name}}</div>
							</div>
						</div>
					</div>
					<div class="class_dialog_list" v-show="class_cur == 'tutor_grade_data'">
						<div v-for="(item,index) in class_data.tutor_grade_data" :class="index">
							<div class="mat20 mab20">{{item.gradeName}}</div>
							<div class="class_dialog_list_cont tc">
								<div class="cur radius8 class_dialog_list_item" v-for="(item,secondIndex) in item.class_data" :key="secondIndex"
								:class="{'on':item.check}" @click="tutorCheck(index,secondIndex)">{{item.name}}</div>
							</div>
						</div>
					</div>
				</div>
				<div class="class_dialog_btm tc mat40">
					<button class="f18px cl_violet radius20 bg_white mar10 class_dialog_cancel" @click="innerVisible = false">取消</button>
					<button class="f18px cl_white radius20 mal10 class_dialog_confirm" @click="classSubmit()">确定</button>
				</div>
			</el-dialog>
			<div class="basket_dialog_cont">
				<div class="basket_dialog_item">
					<div class="basket_dialog_item_l f16px cl_dark"><span>作业标题</span></div>
					<div class="basket_dialog_item_r">
						<input type="text" v-model="basket_name" maxlength="20" placeholder="输入作业标题" class="f16px basket_dialog_item_input" />
					</div>
				</div>
				<div class="basket_dialog_item">
					<div class="basket_dialog_item_l f16px cl_dark"><span>布置对象</span></div>
					<div class="basket_dialog_item_r">
						<div class="basket_dialog_item_class cl_gray f16px" v-if="class_check.length > 0">
							<div v-for="(item,index) in class_check" :key="index" class="radius8">{{item.name}}</div>
						</div>
						<span @click="innerVisible = true" class="cl_violet inline cur basket_dialog_object">{{class_check.length == 0 ? '添加布置对象' : '修改'}}</span>
					</div>
				</div>
				<div class="basket_dialog_item">
					<div class="basket_dialog_item_l f16px cl_dark"><i class="cl_red">*</i><span>作业开始时间</span></div>
					<div class="basket_dialog_item_r flex">
						<div class="flex f16px cl_gray basket_dialog_item_label">
							<label class="flex cur"><input type="radio" :value="1" v-model="set_type" class="mar10" /><span>立即布置</span></label>
							<label class="flex cur"><input type="radio" :value="2" v-model="set_type" class="mar10" /><span>定时布置</span></label>
						</div>
					</div>
				</div>
				<div class="basket_dialog_item" v-show="set_type == 1">
					<div class="basket_dialog_item_l f16px cl_dark"><i class="cl_red">*</i><span>作业截止时间</span></div>
					<div class="basket_dialog_item_r">
						<el-date-picker v-model="end_time" type="datetime" placeholder="选择日期时间"
						 :picker-options="endTimeOption"></el-date-picker>
					</div>
				</div>
				<div class="basket_dialog_item" v-show="set_type == 2">
					<div class="basket_dialog_item_l f16px cl_dark"><i class="cl_red">*</i><span>作业开始与截止时间</span></div>
					<div class="basket_dialog_item_r">
						<el-date-picker v-model="time_range" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
						 :picker-options="rangeTimeOption"></el-date-picker>
					</div>
				</div>
			</div>
			<div class="basket_dialog_btm tc mat50">
				<button type="button" class="basket_dialog_submit f18px cl_white radius20" @click="submit()">确认布置</button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import teacherHeader from '../../components/teacher_header.vue'
	import draggable from 'vuedraggable'
	
	export default {
		name: 'organize_details',
		components: {
			teacherHeader,
			draggable,
		},
		props: {
			
		},
		data () {
			return {
				myInfo: {},
				public: {},
				logo_name: "组卷预览",
				id: "",
				data: {}, //试卷
				edit_show: false, //修改名称
				edit_name: "",
				edit_title_show: false, //修改题型
				edit_title_index: "",
				edit_title_name: "",
				proof_show: false, //解析
				paper_cur: {},
				knowledge_show: false, //保存
				grade: [], //年级
				grade_cur : "",
				material: [], //教材
				material_cur: "",
				chapter: [], //章节
				chapter_cur: "",
				outerVisible: false, //立即布置
				innerVisible: false,
				basket_name: "",
				set_type: 1,
				end_time: "",
				endTimeOption: {
				  disabledDate: date => {
						return date.getTime() < Date.now() - 24 * 60 * 60 * 1000;
				  }
				},
				time_range: "",
				rangeTimeOption: {
				  disabledDate: date => {
						return date.getTime() < Date.now() - 24 * 60 * 60 * 1000;
				  }
				},
				class_data: {},
				class_cur: "",
				class_check: [],
			}
		},
		created() {
			if (this.$route.query.id) {
				this.id = this.$route.query.id;
				this.getBasket();
			}
			if (this.$route.query.paper_id) {
				this.paper_id = this.$route.query.paper_id;
				this.getDetails();
			}
			// 阻止火狐浏览器默认的拖拽搜索行为
			document.body.ondrop = (event) => {
				// 阻止事件默认行为
				event.preventDefault()
				// 阻止时间冒泡
				event.stopPropagation()
			}
		},
		mounted() {
			this.getGrade();
			this.getClass();
		},
		methods: {
			myInfoEvent (data) {
				this.myInfo = data;
			},
			publicEvent (data) {
				this.public = data;
			},
			//组卷详情
			getDetails () {
				this.$get("/api/teacher/get_test_dtl",{
					token: localStorage.getItem("token"),
					id: this.paper_id,
				})
				.then(res => {
					if (JSON.stringify(res.data) != '{}') {
						for (let i = 0; i < res.data.groupList.length; i++) {
							for (let j = 0; j < res.data.groupList[i].question_list.length; j++) {
								res.data.groupList[i].question_list[j].select = false;
							}
							res.data.groupList[i].number = this.toChinesNum(i+1);
						}
					}
					this.data = res.data;
					this.id = this.data.subject_id;
				});
			},
			//年级
			getGrade () {
				this.$get("/api/teacher/get_school_grade_data",{
					token: localStorage.getItem("token"),
				})
				.then(res => {
					this.grade = res.data;
					this.grade_cur = this.grade[0].gradeId;
				});
			},
			//试题篮
			getBasket () {
				this.$get("/api/teacher/get_not_test_data",{
					token: localStorage.getItem("token"),
					subject_id: this.id,
				})
				.then(res => {
					if (JSON.stringify(res.data) != '{}') {
						for (let i = 0; i < res.data.groupList.length; i++) {
							for (let j = 0; j < res.data.groupList[i].question_list.length; j++) {
								res.data.groupList[i].question_list[j].select = false;
							}
							res.data.groupList[i].number = this.toChinesNum(i+1);
						}
					}
					this.data = res.data;
				});
			},
			//修改名称
			editShow () {
				this.edit_show = true;
				this.edit_name = this.data.name;
			},
			editConfirm () {
				this.edit_show = false;
				this.data.name = this.edit_name;
			},
			editTitle (e) {
				this.edit_title_show = true;
				this.edit_title_name = this.data.groupList[e].group_name;
				this.edit_title_index = e;
			},
			editTitleConfirm (e) {
				this.edit_title_show = false;
				this.data.groupList[e].group_name = this.edit_title_name;
			},
			//解析
			proofShow (index,secondIndex) {
				this.paper_cur = this.data.groupList[index].question_list[secondIndex];
				this.proof_show = true;
			},
			//删除
			removeAll (index) {
				this.$messageBox.confirm('确定连所有子题目一起删除吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(() => {
					this.data.groupList.splice(index, 1);
					this.setChines();
				}).catch(() => {
					
				});
			},
			remove (index,secondIndex) {
				this.$messageBox.confirm('确定删除吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(() => {
					this.data.groupList[index].question_list.splice(secondIndex, 1);
				}).catch(() => {
					
				});
			},
			//拖拽
			end (e) {
				this.setChines();
			},
			end2 (e) {
				this.setChines();
			},
			//保存
			save () {
				let ques_json = [];
				let data = this.data;
				let question_num = 0;
				if (this.chapter_cur == "") {
					this.$message({
						duration: 1500,
						message: '请先选择知识点',
						type: 'error'
					});
					return false
				}
				if (data.groupList.length > 0) {
					for (let i = 0; i < data.groupList.length; i++) {
						let question_list = [];
						if (data.groupList[i].question_list.length > 0) {
							for (let j = 0; j < data.groupList[i].question_list.length; j++) {
								question_list.push({questions_id: data.groupList[i].question_list[j].questions_id, sort: data.groupList[i].question_list[j].sort})
								question_num ++
							}
						}
						ques_json.push({group_name: data.groupList[i].group_name, sort: data.groupList[i].sort, question_list: question_list})
					}
				}
				ques_json = JSON.stringify(ques_json);
				this.$get("/api/teacher/post_edit_test",{
					token: localStorage.getItem("token"),
					id: this.data.id,
					name: this.data.name,
					grade_id: this.grade_cur,
					chapter_id: this.chapter_cur,
					ques_json: ques_json,
					question_num: question_num,
				})
				.then(res => {
					this.$message({
						duration: 1500,
						message: res.msg,
						type: 'success'
					});
					setTimeout(() => {
						this.$router.push({path: '/organize',replace: true});
					}, 1500);
				});
			},
			//教材
			knowledgeShow () {
				this.knowledge_show = true;
				this.getMaterial();
			},
			getMaterial () {
				this.$get("/api/teacher/get_subject_chapter_edition_data",{
					token: localStorage.getItem("token"),
					subject_id: this.id,
				})
				.then(res => {
					this.material = res.data;
					this.material_cur = this.material[0].Id;
					this.getChapter();
				});
			},
			materialSelect (e) {
				this.getChapter();
			},
			//章节
			getChapter () {
				this.$get("/api/teacher/get_chapter_data",{
					token: localStorage.getItem("token"),
					subject_id: this.id,
					edition_id: this.material_cur,
				})
				.then(res => {
					this.chapter = [];
					this.chapter_cur = "";
					if (res.data.length > 0) {
						for (let i = 0; i < res.data.length; i++) {
							res.data[i].open = false;
							if (res.data[i].chapter_data.length > 0) {
								for (let j = 0; j < res.data[i].chapter_data.length; j++) {
									res.data[i].chapter_data[j].open = false;
								}
							}
						}
						this.chapter = res.data;
					}
				});
			},
			firstOpen (e) {
				if (this.chapter[e].open) {
					this.chapter[e].open = false;
				} else {
					this.chapter[e].open = true;
				}
			},
			secondOpen (index,secondIndex) {
				if (this.chapter[index].chapter_data[secondIndex].open) {
					this.chapter[index].chapter_data[secondIndex].open = false;
				} else {
					this.chapter[index].chapter_data[secondIndex].open = true;
				}
			},
			knowledgeCheck (id) {
				this.chapter_cur = id;
			},
			//立即布置
			getClass () {
				this.$get("/api/teacher/get_assign_homework_class",{
					token: localStorage.getItem("token"),
				})
				.then(res => {
					for (let i = 0; i < res.data.normal_grade_data.length; i ++) {
						for (let j = 0; j < res.data.normal_grade_data[i].class_data.length; j++) {
							res.data.normal_grade_data[i].class_data[j].check = false;
						}
					}
					for (let k = 0; k < res.data.tutor_grade_data.length; k ++) {
						for (let l = 0; l < res.data.tutor_grade_data[k].class_data.length; l++) {
							res.data.tutor_grade_data[k].class_data[l].check = false;
						}
					}
					this.class_data = res.data;
					this.class_cur = "normal_grade_data";
				});
			},
			normalCheck (index,secondIndex) {
				if (this.class_data.normal_grade_data[index].class_data[secondIndex].check) {
					this.class_data.normal_grade_data[index].class_data[secondIndex].check = false;
				} else {
					this.class_data.normal_grade_data[index].class_data[secondIndex].check = true;
				}
			},
			tutorCheck (index,secondIndex) {
				if (this.class_data.tutor_grade_data[index].class_data[secondIndex].check) {
					this.class_data.tutor_grade_data[index].class_data[secondIndex].check = false;
				} else {
					this.class_data.tutor_grade_data[index].class_data[secondIndex].check = true;
				}
			},
			classSubmit () {
				var arr = [];
				if (this.class_cur == "normal_grade_data") {
					for (let i = 0; i < this.class_data.normal_grade_data.length; i ++) {
						for (let j = 0; j < this.class_data.normal_grade_data[i].class_data.length; j++) {
							if (this.class_data.normal_grade_data[i].class_data[j].check) {
								arr.push(this.class_data.normal_grade_data[i].class_data[j])
							}
						}
					}
				} else {
					for (let i = 0; i < this.class_data.tutor_grade_data.length; i ++) {
						for (let j = 0; j < this.class_data.tutor_grade_data[i].class_data.length; j++) {
							if (this.class_data.tutor_grade_data[i].class_data[j].check) {
								arr.push(this.class_data.tutor_grade_data[i].class_data[j])
							}
						}
					}
				}
				this.class_check = arr;
				this.innerVisible = false;
			},
			getTime (time) {
				let t = "";
				let myDate = new Date(time);
				let year = myDate.getFullYear();
				let month = myDate.getMonth() + 1;
				let date = myDate.getDate();
				let hours = myDate.getHours();
				let minutes = myDate.getMinutes();
				let seconds = myDate.getSeconds();
				if (month < 10) {
					month = "0" + month;
				}
				if (date < 10) {
					date = "0" + date;
				}
				if (hours < 10) {
					hours = "0" + hours;
				}
				if (minutes < 10) {
					minutes = "0" + minutes;
				}
				if (seconds < 10) {
					seconds = "0" + seconds;
				}
				t = year + "-" + month + "-" + date + " " + hours + ":" + minutes + ":" + seconds
				return t;
			},
			submit () {
				var from_time = "";
				var to_time = "";
				var class_ids = [];
				let ques_json = [];
				let data = this.data;
				if (data.groupList.length > 0) {
					for (let i = 0; i < data.groupList.length; i++) {
						let question_list = [];
						if (data.groupList[i].question_list.length > 0) {
							for (let j = 0; j < data.groupList[i].question_list.length; j++) {
								question_list.push({questions_id: data.groupList[i].question_list[j].questions_id, sort: data.groupList[i].question_list[j].sort})
							}
						}
						ques_json.push({group_name: data.groupList[i].group_name, sort: data.groupList[i].sort, question_list: question_list})
					}
				}
				ques_json = JSON.stringify(ques_json);
				if (this.basket_name == "" || this.class_check.length == 0) {
					this.$message({
						type: 'warning',
						message: '请填写完整内容',
						duration: 1500,
					});
					return false
				}
				if (this.set_type == 1) {
					if (this.end_time == "") {
						this.$message({
							type: 'warning',
							message: '请填写完整内容',
							duration: 1500,
						});
						return false
					}
					from_time = "";
					to_time = this.getTime(this.end_time);
				} else {
					if (this.time_range == "") {
						this.$message({
							type: 'warning',
							message: '请填写完整内容',
							duration: 1500,
						});
						return false
					}
					from_time = this.getTime(this.time_range[0]);
					to_time = this.getTime(this.time_range[1]);
				}
				for (let i = 0; i < this.class_check.length; i++) {
					class_ids.push(this.class_check[i].id);
				}
				class_ids = class_ids.join(",");
				this.$get("/api/teacher/post_test_homework",{
					token: localStorage.getItem("token"),
					id: this.data.id,
					ques_json: ques_json,
					name: this.basket_name,
					class_ids: class_ids,
					from_time: from_time,
					to_time: to_time,
				})
				.then(res => {
					this.$message({
						type: 'success',
						message: res.msg,
						duration: 1500,
					});
					setTimeout(() => {
						this.$router.push({path: '/organize',replace: true});
					}, 1500);
				});
			},
			set () {
				
			},
			setChines () {
				if (this.data.groupList.length > 0) {
					for (let i = 0; i < this.data.groupList.length; i ++) {
						this.data.groupList[i].number = this.toChinesNum(i+1)
					}
				}
			},
			//中文序号
			toChinesNum (num) {
				let changeNum = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']; 
				let unit = ["", "十", "百", "千", "万"];
				num = parseInt(num);
				let getWan = (temp) => {
					let strArr = temp.toString().split("").reverse();
					let newNum = "";
					for (var i = 0; i < strArr.length; i++) {
						newNum = (i == 0 && strArr[i] == 0 ? "" : (i > 0 && strArr[i] == 0 && strArr[i - 1] == 0 ? "" : changeNum[strArr[i]] + (strArr[i] == 0 ? unit[0] : unit[i]))) + newNum;
					}
					return newNum;
				}
				let overWan = Math.floor(num / 10000);
				let noWan = num % 10000;
				if (noWan.toString().length < 4) {
					noWan = "0" + noWan;
				}
				return overWan ? getWan(overWan) + "万" + getWan(noWan) : getWan(num);
			},
		},
	}
</script>

<style>
</style>
